<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-sessiontimeout></app-sessiontimeout>
<mat-spinner *ngIf="loader"></mat-spinner>
